"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialValues = void 0;
exports.initialValues = {
    nodeName: '',
    guidelines: '',
};
